import { cn } from '@/lib/utils';
import { FC } from 'react';

type Props = {
    text?: string;
    className?: string;
};

const EPageLoader: FC<Props> = ({ text, className }) => {
    return (
        <div
            className={cn(
                'fixed inset-0 z-50 flex flex-col items-center justify-center bg-background/80 backdrop-blur-sm',
                className,
            )}
        >
            <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
            {text && <p className="mt-4 text-sm text-muted-foreground">{text}</p>}
        </div>
    );
};

export default EPageLoader;
